import { useState, useEffect } from "react";

const useIsMobile = (mobileScreenSize = 991) => {
    const [isMobile, setIsMobile] = useState(false);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
        const media = window.matchMedia(`(max-width: ${mobileScreenSize}px)`);
        const listener = () => setIsMobile(media.matches);
        media.addEventListener("change", listener);
        setIsMobile(media.matches);

        return () => media.removeEventListener("change", listener);
    }, [mobileScreenSize]);

    return isClient ? isMobile : null;
};

export default useIsMobile;
